import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { FLEET, SITE } from "../lib/site";

export default function Fleet() {
  return (
    <>
      <SEO
        title="Fleet — 40-Ton Grove & 50-Ton Manitex Mobile Cranes"
        description="Our Central Florida mobile crane fleet: a 40-ton Grove hydraulic truck crane and a 50-ton Manitex boom truck. Full specs, capacities and reach."
      />

      <section className="border-b border-[var(--ac-border)] bg-black">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-14 md:py-28">
          <div className="overline mb-4">Fleet</div>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl max-w-4xl leading-[0.95]">
            Two cranes. <span className="text-[var(--ac-red)]">90 tons</span> of capacity.
          </h1>
          <p className="mt-6 text-zinc-400 max-w-2xl text-lg leading-relaxed">
            A tight, well-maintained two-crane fleet designed for Central Florida's mix of
            residential, commercial, mechanical and industrial work.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-20">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 space-y-20 md:space-y-28">
          {FLEET.map((f, i) => (
            <article
              key={f.slug}
              id={f.slug}
              data-testid={`fleet-section-${f.slug}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 scroll-mt-28"
            >
              <div className={`md:col-span-7 ${i % 2 ? "md:order-2" : ""}`}>
                <div className="aspect-[4/3] overflow-hidden border border-[var(--ac-border)] bg-black">
                  <img src={f.image} alt={f.name} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className={`md:col-span-5 flex flex-col justify-center ${i % 2 ? "md:order-1" : ""}`}>
                <div className="overline mb-3">{f.type}</div>
                <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95]">{f.name}</h2>
                <p className="mt-5 text-zinc-300 leading-relaxed">{f.blurb}</p>

                <div className="mt-8 border-t border-l border-[var(--ac-border)]">
                  {f.specs.map((s) => (
                    <div key={s.label} className="grid grid-cols-2 border-r border-b border-[var(--ac-border)]">
                      <div className="px-4 py-3 overline">{s.label}</div>
                      <div className="px-4 py-3 font-mono-data text-sm text-white border-l border-[var(--ac-border)]">
                        {s.value}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-8 flex flex-wrap items-center gap-3">
                  <Link to="/contact" className="btn-primary" data-testid={`fleet-cta-${f.slug}`}>
                    Request This Crane <ArrowRight className="w-4 h-4" />
                  </Link>
                  <a href={`tel:${SITE.phoneE164}`} className="btn-ghost">
                    {SITE.phone}
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
